import { useEffect } from 'react'
import Router from 'next/router'
import { useDispatch } from 'react-redux'
import { closeModal } from '../state/modals/actions'

const useCloseModal = () => {
  const dispatch = useDispatch()
  useEffect(() => {
    const handleRouteChange = () => {
      dispatch(closeModal(''))
    }

    Router.events.on('routeChangeStart', handleRouteChange)
    return () => {
      Router.events.off('routeChangeStart', handleRouteChange)
    }
  }, [])
}

export default useCloseModal
